// post和get请求的封装
import axios from './request';
// import QS from 'qs';
import BASE_URL from './base';
// console.log({BASE_URL});
/**
 * post方法，对应post请求
 * @desc注册请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
let configUrl = BASE_URL;
console.log(configUrl, process.env.NODE_ENV);
let commonParams = (params) => {
  // console.log({params});
    if (params.needComPms) {
      const getLoginData = JSON.parse(localStorage.getItem('loginData')) || ''; // 登录获取的数据
      let typeParams = {};
        if (getLoginData.storeId == null) {
            typeParams = { loginEnterpriseId: getLoginData.enterpriseId };
        } else {
            typeParams = { loginStoreIds: [getLoginData.storeId] };
        }
        Object.assign(params, typeParams);
        delete params.needComPms;
        return params;
    } else {
        return params;
    }
}
let https = {
    post: function (url, params) {
        return axios({
            url: `/api/${url}`,
            method: 'post',
            // data: QS.stringify(data)
            data: commonParams(params)
        });
    },
    put: function (url, params) {
        return axios({
            url: `/api/${url}`,
            method: 'put',
            data: commonParams(params)
        });
    },
    get: function (url, params) {
        return axios({
            url: `/api/${url}`,
            method: 'get',
            params: commonParams(params)
        });
    },
    delete: function (url, params) {
        return axios({
            url: `/api/${url}`,
            method: 'delete',
            params: commonParams(params)
        });
    },
    smsPost: function (url, params) {
        return axios({
            url: `/sms/${url}`,
            method: 'post',
            params: commonParams(params)
            // data: QS.stringify(data)
        });
    },
}
export default https;
